import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';
import * as validators from '../../util/validators';
import {
  Form,
  PrimaryButton,
  FieldTextInput,
  NamedLink,
  FieldPhoneNumberInput,
  FieldPhoneNumberInputWithDialCode,
  FieldPassword,
} from '../../components';
import arrayMutators from 'final-form-arrays';
import css from './SignupForm.module.css';
import config from '../../config';
import ProviderSignup from './ProviderSignup';
import {
  COMPANY_SIGN_UP,
  WORKER_SIGN_UP,
  workerAllowedOptions,
} from '../../marketplace-custom-config';
import CustomerSignup from './CustomerSignup';

const KEY_CODE_ENTER = 13;

const SignupFormComponent = props => {
  return (
    <FinalForm
      {...props}
      mutators={{ ...arrayMutators }}
      render={fieldRenderProps => {
        const {
          rootClassName,
          className,
          formId,
          inProgress,
          invalid,
          intl,
          onOpenTermsOfService,
          tab,
          values,
          history,
          form,
          onManageDisableScrolling,
          userNativeLang,
          errors,
          errorMessage,
          isEmailTakenError,
          currentUserLoaded,
          user,
          isAuthenticated,
          currentSignupUserLoaded,
          currentSignupUser,
          onFetchCurrentUser,
          onAddOrUpdateWorkerExtraDetails,
          socialLoginButtonsMaybe,
          onUpdateProfile,
  
        } = fieldRenderProps;

        return tab === COMPANY_SIGN_UP ? (
          <ProviderSignup
            intl={intl}
            values={values}
            inProgress={inProgress}
            invalid={invalid}
            onOpenTermsOfService={onOpenTermsOfService}
            formId={formId}
            formApi={form}
            onSubmit={props.onSubmit}
            className={className}
            rootClassName={rootClassName}
            history={history}
            onManageDisableScrolling={onManageDisableScrolling}
            userNativeLang={userNativeLang}
            error={errors}
            signupErrorMessage={errorMessage}
            isEmailTakenError={isEmailTakenError}
            socialLoginButtonsMaybe={socialLoginButtonsMaybe}

          />
        ) : tab === WORKER_SIGN_UP ? (
          <CustomerSignup
            intl={intl}
            values={values}
            inProgress={inProgress}
            invalid={invalid}
            onOpenTermsOfService={onOpenTermsOfService}
            formId={formId}
            formApi={form}
            onSubmit={props.onSubmit}
            className={className}
            rootClassName={rootClassName}
            history={history}
            onManageDisableScrolling={onManageDisableScrolling}
            userNativeLang={userNativeLang}
            error={errors}
            signupErrorMessage={errorMessage}
            isEmailTakenError={isEmailTakenError}
            currentUserLoaded={currentUserLoaded}
            currentUser={user}
            isAuthenticated={isAuthenticated}
            currentSignupUserLoaded={currentSignupUserLoaded}
            currentSignupUser={currentSignupUser}
            onFetchCurrentUser={onFetchCurrentUser}
            onAddOrUpdateWorkerExtraDetails={onAddOrUpdateWorkerExtraDetails}
            socialLoginButtonsMaybe={socialLoginButtonsMaybe}
            onUpdateProfile={onUpdateProfile}
          />
        ) : null;
      }}
    />
  );
};

SignupFormComponent.defaultProps = { inProgress: false };

const { bool, func } = PropTypes;

SignupFormComponent.propTypes = {
  inProgress: bool,

  onOpenTermsOfService: func.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const SignupForm = compose(injectIntl)(SignupFormComponent);
SignupForm.displayName = 'SignupForm';

export default SignupForm;
